import { render, staticRenderFns } from "./DailyUpdates.vue?vue&type=template&id=464792fc&"
import script from "./DailyUpdates.vue?vue&type=script&lang=js&"
export * from "./DailyUpdates.vue?vue&type=script&lang=js&"
import style0 from "./DailyUpdates.vue?vue&type=style&index=0&id=464792fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports